import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'messageTimestamp',
  standalone: true
})
export class MessageTimestampPipe implements PipeTransform {
  transform(utcDate: string | Date): string {
    if (!utcDate) return '';
    
    let timeZone = localStorage.getItem('timezonedate');
    if (!timeZone || timeZone === 'null' || timeZone === 'undefined') {
      timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    if (!timeZone || typeof timeZone !== 'string' || timeZone.trim() === '') {
      return '';
    }

    const parsedDate = new Date(utcDate);
    if (isNaN(parsedDate.getTime())) {
      return '';
    }

    try {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const messageDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
      
      const options: Intl.DateTimeFormatOptions = { timeZone };
      
      // Check if the message was sent today
      if (messageDate.getTime() === today.getTime()) {
        // Show time only (e.g., "09:55 PM")
        options.hour = '2-digit';
        options.minute = '2-digit';
        options.hour12 = true;
      } else {
        // Show date only (e.g., "08/07/2026")
        options.year = 'numeric';
        options.month = '2-digit';
        options.day = '2-digit';
      }
      
      return new Intl.DateTimeFormat('en-US', options).format(parsedDate);
    } catch (error) {
      return '';
    }
  }
}
